import { Popover, PopoverItem } from '@enter/core';
import { mdiMenuDown } from '@mdi/js';
import _ from 'lodash';
import React from 'react';
import { DateRangeType } from '../../stores';
import * as S from './date-type-select.styles';

interface IDateTypeSelectProps {
    className?: string;
    value: DateRangeType;
    onChange: (type: DateRangeType) => void;
}

export const DateTypeSelect: React.FunctionComponent<IDateTypeSelectProps> = (props: IDateTypeSelectProps) => {
    const { className, onChange, value } = props;
    const options = [
        { type: 'service', label: 'Service Date' },
        { type: 'billing', label: 'Billing Date' },
    ];
    const renderButton = () => {
        const option = _.find(options, { type: value }) || options[0];
        return (
            <S.Select>
                Select by {option.label}
                <S.SelectIcon path={mdiMenuDown} />
            </S.Select>
        );
    };
    const renderItems = () => {
        return _.map(options, option => (
            <PopoverItem
                key={option.type}
                selected={value === option.type}
                onClick={handleClick(option.type as DateRangeType)}>
                {option.label}
            </PopoverItem>
        ));
    };
    const handleClick = (type: DateRangeType) => {
        return () => {
            onChange(type);
        };
    };
    return (
        <Popover className={className} renderButton={renderButton}>
            {renderItems()}
        </Popover>
    );
};
